import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private readonly sidebarDisabledSubject = new BehaviorSubject<boolean>(false);

  // Expose as observable for other components
  sidebarDisabled$ = this.sidebarDisabledSubject.asObservable();

  constructor() { }

  setSidebarDisabled(value: boolean) {
    this.sidebarDisabledSubject.next(value);
  }

  getSidebarDisabled(): boolean {
    return this.sidebarDisabledSubject.getValue();
  }
}
